import styled from 'styled-components';

export const NavigationIcons = styled.div`
    color: #214781;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    cursor: pointer;

    img {
        display: none;
    }

    label {
        font-size: 16px;
        line-height: 19px;
        color: ${({ theme }) => theme.colors.blue};
        cursor: pointer;
        font-family: ${({ theme }) => theme.font.defaults.fontFamily};
    }

    @media screen and (max-width: 769px) {
        label {
            font-size: 16px;
            line-height: 19px;
            color: ${({ theme }) => theme.colors.white};
            cursor: pointer;
            font-family: ${({ theme }) => theme.font.defaults.fontFamily};
        }
        img {
            display: block;
        }
    }
`;

export const OptionsWrapper = styled.div<any>`
    position: relative;
    img {
        display: none;
    }
    @media screen and (max-width: 769px) {
        ${({ isActive }) =>
            isActive &&
            `background-color: #1d3146;
            }`}

        img {
            display: block;
            transition: transform 200ms ease-out 0s;
            transform: rotate(${({ isActive }) => (isActive ? '180deg' : '0deg')});
        }
    }
`;

export const OptionLabel = styled.div<any>`
    img {
        display: none;
    }
    @media screen and (max-width: 769px) {
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        align-items: center;
        img {
            display: block;
        }
        ${({ isActive }) => isActive && `background-color: #1d3146; padding: 15px 20px;`}
    }
`;

export const SingleOption = styled.div`
    padding: 0 20px;
`;
